<a
  class="myre-menu-item"
  [ngClass]="type()"
  [class.hasChildren]="_hasChildren()"
  [class.active]="_isTheClosestRouteActive()"
  [routerLink]="item().absolutePath"
  routerLinkActive
  [routerLinkActiveOptions]="{
    paths: 'subset',
    fragment: 'ignored',
    queryParams: 'ignored',
    matrixParams: 'ignored',
  }"
  (isActiveChange)="_handleActiveChange($event)"
  (click)="_handleItemClick()"
>
  <div class="left">
    @if (_hasChildren()) {
      <i class="myre-icon-arrow_dropdown" [class.expanded]="_expanded()"></i>
    }

    @if (item().icon) {
      <i class="{{ item().icon }}"></i>
    }

    <span ellipsis>{{ item().label }}</span>
  </div>

  @if (item().secondaryIcon) {
    <i class="icon--secondary" [ngClass]="item().secondaryIcon"></i>
  }

  @if (_isHome()) {
    <i
      class="icon--secondary icon--home myre-icon-home"
      (click)="_openHomeSelector($event)"
    ></i>
  }
</a>

@if (_expanded()) {
  <ng-content />
}
